/* =================================================================
   SAYURI · SAMPLE SET (Discovery Kit picker)
   Companion JS for sections/sayuri-sample-set.liquid

   Behaviour:
   - Steppers per scent card; repeats allowed up to per-scent stock cap
     AND a global "max samples" budget (data-max on the section).
   - "Add discovery kit" posts, in one /cart/add.js call:
       * one line per chosen scent (its $0 tracked sample variant, qty),
         tagged with a hidden `_discovery_kit` property, and
       * one flat-priced kit line (data-kit-variant) carrying a readable
         "Your samples" summary property.
     Cart total = the flat kit price regardless of sample count.
   - Refreshes/opens the cart drawer via themeCore EventBus; falls back
     to /cart on older cores or if the add fails softly.
   ================================================================= */
(function () {
  "use strict";

  function initSection(section) {
    var maxSamples = parseInt(section.getAttribute("data-max"), 10) || 3;
    var kitVariant = section.getAttribute("data-kit-variant");
    var addBtn = section.querySelector("[data-add]");
    var countEl = section.querySelector("[data-count]");
    var chosenEl = section.querySelector("[data-chosen]");
    var msgEl = section.querySelector("[data-msg]");
    var cards = Array.prototype.slice.call(section.querySelectorAll(".samp-card[data-variant]"));

    if (!addBtn || !kitVariant || !cards.length) return;

    // variantId -> { qty, name, cap, el, qtyEl, minusBtn, plusBtn }
    var state = {};

    cards.forEach(function (card) {
      if (card.getAttribute("data-available") !== "true") return;
      var vid = card.getAttribute("data-variant");
      var cap = parseInt(card.getAttribute("data-cap"), 10);
      if (isNaN(cap) || cap < 0) cap = maxSamples;
      var entry = {
        qty: 0,
        name: card.getAttribute("data-name") || "Sample",
        cap: cap,
        el: card,
        qtyEl: card.querySelector("[data-qty]"),
        minusBtn: card.querySelector(".samp-step--minus"),
        plusBtn: card.querySelector(".samp-step--plus")
      };
      state[vid] = entry;

      if (entry.plusBtn) {
        entry.plusBtn.addEventListener("click", function () { change(vid, 1); });
      }
      if (entry.minusBtn) {
        entry.minusBtn.addEventListener("click", function () { change(vid, -1); });
      }
    });

    function total() {
      var t = 0;
      for (var k in state) { if (state.hasOwnProperty(k)) t += state[k].qty; }
      return t;
    }

    function change(vid, delta) {
      var e = state[vid];
      if (!e) return;
      var next = e.qty + delta;
      if (next < 0) return;
      if (delta > 0) {
        if (e.qty >= e.cap) return;        // per-scent stock cap
        if (total() >= maxSamples) return; // global budget
      }
      e.qty = next;
      render();
    }

    function render() {
      var t = total();
      var atMax = t >= maxSamples;

      cards.forEach(function (card) {
        var vid = card.getAttribute("data-variant");
        var e = state[vid];
        if (!e) return;
        if (e.qtyEl) e.qtyEl.textContent = String(e.qty);
        card.classList.toggle("is-selected", e.qty > 0);
        if (e.minusBtn) e.minusBtn.disabled = e.qty <= 0;
        if (e.plusBtn) e.plusBtn.disabled = e.qty >= e.cap || atMax;
      });

      if (countEl) countEl.textContent = String(t);

      // Readable summary: "Momiji ×2 · Tea Garden ×1"
      var parts = [];
      for (var k in state) {
        if (state.hasOwnProperty(k) && state[k].qty > 0) {
          parts.push(state[k].name + (state[k].qty > 1 ? " ×" + state[k].qty : ""));
        }
      }
      if (chosenEl) {
        chosenEl.textContent = parts.length ? parts.join(" · ") : "Pick your samples above.";
      }
      addBtn.disabled = t === 0;
      clearMsg();
    }

    function clearMsg() {
      if (!msgEl) return;
      msgEl.textContent = "";
      msgEl.classList.remove("is-error");
    }
    function showMsg(text, isError) {
      if (!msgEl) return;
      msgEl.textContent = text;
      msgEl.classList.toggle("is-error", !!isError);
    }

    function summaryText() {
      var parts = [];
      for (var k in state) {
        if (state.hasOwnProperty(k) && state[k].qty > 0) {
          parts.push(state[k].name + (state[k].qty > 1 ? " ×" + state[k].qty : ""));
        }
      }
      return parts.join(" · ");
    }

    function buildItems() {
      var items = [];
      // Unique id linking this kit fee line to its sample lines. It lets the
      // cart guard enforce the kit<->samples pairing, and makes each "Add" a
      // DISTINCT group so Shopify can't merge the kit line to qty 2 on re-add.
      // Phase 2's server-side cart-transform Function groups on this same id.
      var kitGroup = "kg_" + Date.now().toString(36) + Math.random().toString(36).slice(2, 8);
      for (var k in state) {
        if (state.hasOwnProperty(k) && state[k].qty > 0) {
          items.push({
            id: Number(k),
            quantity: state[k].qty,
            properties: { _discovery_kit: "yes", _kit_group: kitGroup }
          });
        }
      }
      // The flat-fee kit line carries the human-readable summary + the group id.
      items.push({
        id: Number(kitVariant),
        quantity: 1,
        properties: { "Your samples": summaryText(), _kit_group: kitGroup }
      });
      return items;
    }

    /* ── Change mode ──────────────────────────────────────────────
       The cart's "Change samples" link arrives with ?change=<kit_group>.
       Prefill the picker from that group's sample lines; on Add, the new
       kit REPLACES the old group. Order matters: the new group is added
       first and the old zeroed after, so a failure can never leave the
       customer kit-less (worst case: two kits, both visible/removable).
       The two groups coexisting briefly is safe — the cart guard treats
       each _kit_group independently. ─────────────────────────────── */
    var changeGroup = null;
    try {
      changeGroup = new URLSearchParams(window.location.search).get("change") || null;
    } catch (e) {}

    function enterChangeMode(cart) {
      var sampleLines = (cart.items || []).filter(function (i) {
        return i.properties && i.properties._kit_group === changeGroup && i.handle !== "discovery-kit";
      });
      if (!sampleLines.length) { changeGroup = null; return; } // group gone — plain add mode
      sampleLines.forEach(function (i) {
        var e = state[String(i.variant_id)];
        if (e) e.qty = Math.min(i.quantity, e.cap);
      });
      if (!addBtn.dataset.origLabel) addBtn.dataset.origLabel = addBtn.textContent;
      addBtn.textContent = "Update samples";
      render();
    }
    if (changeGroup) {
      fetch("/cart.js", { credentials: "same-origin" })
        .then(function (r) { return r.json(); })
        .then(enterChangeMode)
        .catch(function () { changeGroup = null; });
    }

    function removeOldGroup() {
      if (!changeGroup) return Promise.resolve(false);
      var oldGroup = changeGroup;
      changeGroup = null; // one-shot: a second Add must not remove the NEW kit
      try { history.replaceState(null, "", window.location.pathname); } catch (e) {}
      return fetch("/cart.js", { credentials: "same-origin" })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var updates = {};
          (cart.items || []).forEach(function (i) {
            if (i.properties && i.properties._kit_group === oldGroup) updates[i.key] = 0;
          });
          if (!Object.keys(updates).length) return true;
          return fetch("/cart/update.js", {
            method: "POST",
            headers: { "Content-Type": "application/json", Accept: "application/json" },
            credentials: "same-origin",
            body: JSON.stringify({ updates: updates })
          }).then(function () { return true; });
        })
        .catch(function () { return true; }); // old kit lingers at worst — visible + removable in cart
    }

    function refreshCartUI() {
      var core = window.themeCore;
      if (core && core.EventBus && typeof core.EventBus.emit === "function") {
        // The kit was added with a raw /cart/add.js, whose response has no
        // top-level item_count — so nothing has told the header badge to update.
        // GET_CART emits cart:updated WITH item_count, which the header listens
        // for, so fire it (fire-and-forget) to sync the count.
        if (core.CartApi && typeof core.CartApi.makeRequest === "function") {
          try { core.CartApi.makeRequest(core.CartApi.actions.GET_CART).catch(function () {}); } catch (e) {}
        }
        core.EventBus.emit("cart:drawer:refresh-and-open");
        core.EventBus.emit("cart:refresh");
        return true;
      }
      return false;
    }

    addBtn.addEventListener("click", function () {
      if (addBtn.disabled) return;
      var items = buildItems();
      if (items.length <= 1) return; // only the kit fee, no samples

      addBtn.classList.add("is-loading");
      addBtn.disabled = true;
      clearMsg();

      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body: JSON.stringify({ items: items })
      })
        .then(function (res) {
          return res.json().then(function (data) { return { ok: res.ok, data: data }; });
        })
        .then(function (r) {
          addBtn.classList.remove("is-loading");
          if (!r.ok) {
            addBtn.disabled = false;
            var m = (r.data && r.data.description) || (r.data && r.data.message) ||
              "Sorry — one of those samples just sold out. Adjust your picks and try again.";
            showMsg(m, true);
            return;
          }
          var wasChange = !!changeGroup;
          // In change mode, zero the OLD kit group before refreshing the UI so
          // the drawer opens on the final replaced state.
          return removeOldGroup().then(function () {
            if (!refreshCartUI()) {
              window.location.href = "/cart";
            } else {
              showMsg(wasChange ? "Kit updated." : "Added to your cart.", false);
              if (wasChange && addBtn.dataset.origLabel) addBtn.textContent = addBtn.dataset.origLabel;
              // reset picker so re-adding is intentional
              for (var k in state) { if (state.hasOwnProperty(k)) state[k].qty = 0; }
              render();
            }
          });
        })
        .catch(function () {
          addBtn.classList.remove("is-loading");
          addBtn.disabled = false;
          showMsg("Something went wrong adding to cart. Please try again.", true);
        });
    });

    render();
  }

  function init() {
    document.querySelectorAll(".sayuri-samples[data-kit-variant]").forEach(initSection);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  // Re-init when the section is re-rendered in the theme editor.
  document.addEventListener("shopify:section:load", function (e) {
    var sec = e.target.querySelector(".sayuri-samples[data-kit-variant]");
    if (sec) initSection(sec);
  });
})();
